import { PostalCodeResult } from "../../Types/PostalCodeResultType";
import api from "../axios";

export const postalCodeService = {
  getAddressByPostalCode: async (cep: string): Promise<PostalCodeResult> => {
    const response = await api.get(`/postal-code/${cep}`);
    return response.data;
  }
};
